import { createApp } from 'vue'
import App from './App.vue'
import '@/assets/reset.css'

createApp(App).mount('#app')
